import { render, staticRenderFns } from "./NewsCenter.vue?vue&type=template&id=3db0a83c&scoped=true"
import script from "./NewsCenter.vue?vue&type=script&lang=js"
export * from "./NewsCenter.vue?vue&type=script&lang=js"
import style0 from "./NewsCenter.vue?vue&type=style&index=0&id=3db0a83c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db0a83c",
  null
  
)

export default component.exports